// @flow
import React from 'react';
import { connect } from 'react-redux';
import { MdSearch } from 'react-icons/lib/md';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroller';
import i18n from 'i18n-js';

import styles from './reportTable.css';
import DataTable from '../../DataTable';
import TextColumn from '../../DataTable/Columns/Text';
import PlaceholderView from '../../PlaceholderViews';
import PlaceholderImage from '../../../../assets/images/reportsph.png';

import * as selectors from '../../../reducers';
import * as routesActions from '../../../actions/routes';

const LANG = 'ES';
type ReportTablePropTypes = {
  _name: string,
  hasData: boolean,
  _isFetchingReport: boolean,
  reportData: Object,
  _selected: string,
};


const ReportTable = ({
  _name = '',
  hasData,
  _isFetchingReport,
  reportData,
  _selected = 'bus_arrivals_departure_time',
}: ReportTablePropTypes) => {
  let content = (
    <div className={styles.placeholder}>
      <PlaceholderView
        size="large"
        image={PlaceholderImage}
        title={i18n.t('reports.noResults', { count: 2 })}
        subtitle={"No se han encontrado datos con los filtros establecidos."} />
    </div>
  )

  if (hasData) {
    const headers = reportData.headers ? reportData.headers.map(
      header => reportData.friendly_names[LANG][header],
    ) : [];
    if (!Array.isArray(reportData)) {
      const rawData = reportData.raw_data.map((elm) => {
        const current = {};
        for (const key in elm) {
          const c_index = reportData.headers.indexOf(key);
          const c_type = reportData.types[key];
          const date = moment.utc(elm[key], 'HH:mm:ss');
          if (date.isValid() && c_type === 'time') {
            current[key] = date.local().format('HH:mm:ss');
          } else {
            current[key] = elm[key];
          }
        }
        return current;
      });
    }
    content = (
      <InfiniteScroll
        pageStart={1}
        useWindow
        style={{ width: '100%', height: '100%' }}
      >
        <div className={`${styles.dataTable}`}>
          {!Array.isArray(reportData)
            ? <DataTable
              data={reportData.raw_data}
              columns={
                headers.map((header, i) => (
                  TextColumn({
                    Header: header,
                    accessor: reportData.headers[i],
                    minWidth: 150,
                    editable: false,
                    Cell: (row) => {
                      if (!reportData.metadata) {
                        return (
                          <span>
                            {' '}
                            {row.value}
                            {' '}
                          </span>);
                      }
                      if (!reportData.metadata[reportData.headers[i]]) {
                        return (
                          <span>
                            {' '}
                            {row.value}
                            {' '}
                          </span>);
                      }
                      if (!reportData.metadata[reportData.headers[i]].csv_delimeter) {
                        return (
                          <span>
                            {' '}
                            {row.value}
                            {' '}
                          </span>);
                      }

                      const separator = reportData.metadata[reportData.headers[i]].csv_delimeter;
                      let subdata = ['--'];
                      if (typeof row.row[reportData.headers[i]] === 'string') {
                        subdata = row.row[reportData.headers[i]].split(separator);
                      }


                      return (
                        <div className={styles.multipleCellData}>
                          {subdata.map((e, j) => <div key={j}>
                            {' '}
                            {e}
                            {' '}
                          </div>)}
                        </div>
                      );
                    },
                  })))
              }
              minRows={0}
              showPagination={false}
            />
            : reportData.map(table => {
              const headersCurrent = table.headers ? table.headers.map(
                header => table.friendly_names[LANG][header],
              ) : [];
              return (
                <DataTable
                  className={styles.upperMargin}
                  data={table.raw_data}
                  columns={
                    headersCurrent.map((header, i) => (
                      TextColumn({
                        Header: header,
                        accessor: table.headers[i],
                        minWidth: 150,
                        editable: false,
                        Cell: (row) => {
                          if (!table.metadata) {
                            return (<span>
                            {' '}
                              {row.value}
                              {' '}
                          </span>);
                          }
                          if (!table.metadata[table.headers[i]]) {
                            return (<span>
                            {' '}
                              {row.value}
                              {' '}
                          </span>);
                          }
                          if (!table.metadata[table.headers[i]].csv_delimeter) {
                            return (<span>
                            {' '}
                              {row.value}
                              {' '}
                          </span>);
                          }

                          const separator = table.metadata[table.headers[i]].csv_delimeter;
                          const subdata = row.row[table.headers[i]].split(separator);

                          return (
                            <div className={styles.multipleCellData}>
                              {subdata.map((e, i) => <div key={i}>
                                {' '}
                                {e}
                                {' '}
                              </div>)}
                            </div>
                          );
                        },
                      })))
                  }
                  minRows={0}
                  showPagination={false}
                />
              )
            })
          }

        </div>
      </InfiniteScroll>
    );
  }
  return (
    <div className={styles.reportTable}>
      {
        content
      }
    </div>
  );
};

export default connect(
  (state) => {
    /* const _selected = ''; */
    const reportData = selectors.getReportData(state);
    return {
      test: 1,
      isFetchingReport: true,
      hasData: Object.keys(reportData).length > 0,
      reportData,
    };
  },
  dispatch => ({
    onClick(rs) {
      dispatch(routesActions.setCurrentRouteStop(rs.id));
    },
  }),
)(ReportTable);



// WEBPACK FOOTER //
// ./src/scripts/components/ReportDisplay/ReportTable/index.jsx